import type { QuoteTranslations } from '../../types';

export const frQuote: QuoteTranslations = {
  getQuote: 'Obtenir un devis',
  title: 'Obtenir un devis gratuit',
  modal: {
    title: 'Obtenir un devis gratuit',
    subtitle: 'Remplissez les d\u00E9tails ci-dessous et notre \u00E9quipe vous r\u00E9pondra dans les 24 heures.',
    fullName: 'Nom complet',
    email: 'E-mail',
    phone: 'T\u00E9l\u00E9phone',
    productInterest: 'Produit int\u00E9ress\u00E9',
    message: 'Message',
    placeholderName: 'Jean Dupont',
    placeholderEmail: 'jean@exemple.com',
    placeholderPhone: '+33 1 23 45 67 89',
    placeholderProduct: 'ex. : Radiateur industriel',
    placeholderMessage: 'D\u00E9tails du projet, quantit\u00E9, exigences de tension...',
    submit: 'Envoyer la demande',
    successTitle: 'Demande re\u00E7ue !',
    successMessage: 'Merci pour votre int\u00E9r\u00EAt. L\'un de nos sp\u00E9cialistes en chauffage examinera vos exigences et vous contactera sous peu.',
    close: 'Fermer',
  },
  name: 'Votre nom',
  email: 'Adresse e-mail',
  phone: 'Num\u00E9ro de t\u00E9l\u00E9phone',
  company: 'Nom de l\'entreprise',
    message: 'Message',
  submit: 'Envoyer la demande',
  success: 'Merci ! Nous vous contacterons bient\u00F4t.',
};
